import Box from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";
import { isSelfHostedDistribution } from "utils/distribution";
import useIsLearnViewAvailable from "hooks/useIsLearnViewAvailable";
import useTypedFlags from "hooks/useTypedFlags";
import { AccountContext } from "views/AccountWrapper";

import styles from "./styles.module.css";
import DashboardOverviewColumnLearn from "./Learn";
import DashboardOverviewColumnOnboardingSaaS from "./OnboardingSaaS";
import DashboardOverviewColumnTestPilot from "./TestPilot";
import DashboardOverviewColumnUserActivity from "./UserActivity";
import { DashboardContext } from "../context";
import { OverviewStaticWidget } from "../types";
import DashboardOverviewColumnOnboardingSelfHosted from "./OnboardingSelfHosted";
import DashboardOverviewColumnAnnouncement from "./Announcement";
import { getBannerProps, shouldRenderBanner } from "./Announcement/helpers";
import { IAC_CONF_ANNOUNCEMENT_ID } from "./IacConfAnnouncement/constants";
import DashboardOverviewColumnIacConfAnnouncement from "./IacConfAnnouncement";
import DashboardOverviewColumnSurvey from "./Survey";

const isSelfHosted = isSelfHostedDistribution();

const DashboardOverviewColumn = () => {
  const { feMarketingBanners, spaceliftTestPilotProgramDashboardWidget, aiSurvey } =
    useTypedFlags();
  const isLearnViewAvailable = useIsLearnViewAvailable();
  const { viewer, spaceliftIntelligenceEnabled } = useTypedContext(AccountContext);
  const { config } = useTypedContext(DashboardContext);
  const tab = config["overview"];
  const widgets = tab.overviewColumn
    ? tab.overviewColumn.reduce((acc, next) => {
        if (next.hidden) return acc;

        return [...acc, next.value];
      }, [] as OverviewStaticWidget[])
    : [];

  return (
    <Box
      className={styles.overviewColumn}
      gap="x-large"
      direction="column"
      padding="x-large x-large x-large 0"
    >
      {aiSurvey && spaceliftIntelligenceEnabled && <DashboardOverviewColumnSurvey />}
      {feMarketingBanners.map((banner) => {
        if (!shouldRenderBanner(banner.expirationDate)) return null;

        if (banner.id === IAC_CONF_ANNOUNCEMENT_ID) {
          return <DashboardOverviewColumnIacConfAnnouncement key={banner.id} />;
        }

        const bannerProps = getBannerProps(banner.id);
        if (!bannerProps) return null;

        return <DashboardOverviewColumnAnnouncement key={banner.id} {...bannerProps} />;
      })}
      {widgets.includes(OverviewStaticWidget.Learn) && isLearnViewAvailable && (
        <DashboardOverviewColumnLearn />
      )}
      {widgets.includes(OverviewStaticWidget.LaunchPad) &&
        viewer.admin &&
        !isLearnViewAvailable &&
        (isSelfHosted ? (
          <DashboardOverviewColumnOnboardingSelfHosted />
        ) : (
          <DashboardOverviewColumnOnboardingSaaS />
        ))}
      {widgets.includes(OverviewStaticWidget.UserActivity) && viewer.admin && (
        <DashboardOverviewColumnUserActivity />
      )}
      {spaceliftTestPilotProgramDashboardWidget && <DashboardOverviewColumnTestPilot />}
    </Box>
  );
};

export default DashboardOverviewColumn;
